import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store";

class CrmServicesDataService {
    getPartnersContacts(): Promise<any> {
        
      return http.clientComercial.get("PAR_ParteneriHelpers/GetParteneriCrmContacts");
    } 
    save(data: any): Promise<any> {
      return http.clientComercialOdata.post("PAR_ParteneriHelpers/GetParteneriCrmContacts", data);
    }

    
}

export default new CrmServicesDataService();